export default {
    dependencies: [
        '$element',
        'xhrservice',
        'templateservice',
        'statisticsservice',
        'trackingservice',
        'DetailsPolyfill',
    ],
    // eslint-disable-next-line max-params
    callable(
        element,
        xhrService,
        templateService,
        statisticsService,
        trackingservice,
        DetailsPolyfill
    ) {
        let realestate = false;
        const countersEl = element.querySelector('[data-statistics-counters]');
        const loadingEl = element.querySelector('[data-statistics-loader]');

        const data = xhrService.request({
            url: statisticsService.createUrl(element).toString(),
        });

        const d3 = new Promise(resolve => {
            if (browserSupportsSVG()) {
                const scriptElement = document.createElement('script');
                scriptElement.src = '/js/lib/c3js/d3_c3.min.js';
                document.body.appendChild(scriptElement);
                scriptElement.onload = resolve;
            } else {
                resolve();
            }
        });

        Promise.all([data, d3]).then(data => success(data[0]), error);

        function browserSupportsSVG() {
            // NOTE: This check is from Modernizr.js. See https://github.com/Modernizr/Modernizr/blob/master/feature-detects/svg/inline.js
            const div = document.createElement('div');
            div.innerHTML = '<svg/>';

            return (
                (div.firstChild && div.firstChild.namespaceURI) ===
                'http://www.w3.org/2000/svg'
            );
        }

        function error() {
            loadingEl.remove();
            render(countersEl, 'error', {
                msg:
                    'Beklager, vi klarte ikke hente opp annonsestatistikken din. Prøv igjen senere.',
            });
        }

        function success(data) {
            loadingEl.remove();

            if (element.hasAttribute('data-adtype')) {
                realestate = /\brealestate/.test(
                    element.getAttribute('data-adtype')
                );
            }

            render(
                element.querySelector('[data-statistics-counters]'),
                'counters',
                data
            );

            const daysSincePublished = getDaysSincePublished(data.adViewsTotal);

            const availableRanges = {
                0: daysSincePublished,
                1: 14,
                2: 30,
            };

            const rangeSelectorEl = element.querySelector(
                '[data-statistics-range-selector]'
            );

            rangeSelectorEl.onchange = function() {
                const range = statisticsService.getDisplayRange(
                    daysSincePublished,
                    availableRanges[this.value]
                );

                renderCountersChart(daysSincePublished, range, data);
                renderCounterSummary(daysSincePublished, range, data);

                trackingservice.trackEvent('other.statistics-period.click');
            };

            renderCountersChart(
                daysSincePublished,
                availableRanges[rangeSelectorEl.value],
                data
            );
            renderCounterSummary(
                daysSincePublished,
                availableRanges[rangeSelectorEl.value],
                data
            );

            const counterHelpEle = element.querySelector(
                '[data-statistics-counter-help]'
            );
            if (counterHelpEle) {
                counterHelpEle.addEventListener('toggle', () =>
                    trackingservice.trackEvent(
                        'other.statistics-counters-help.click'
                    )
                );
            }

            renderNumbers(data);

            const numbersHelpEle = element.querySelector(
                '[data-statistics-numbers-help]'
            );
            if (numbersHelpEle) {
                numbersHelpEle.addEventListener('toggle', () =>
                    trackingservice.trackEvent(
                        'other.statistics-numbers-help.click'
                    )
                );
            }

            renderVisitorsSummary(data);
            renderVisitorsChart(data);

            const visitorsHelpEle = element.querySelector(
                '[data-statistics-visitors-help]'
            );
            if (visitorsHelpEle) {
                visitorsHelpEle.addEventListener('toggle', () =>
                    trackingservice.trackEvent(
                        'other.statistics-visitors-help.click'
                    )
                );
            }
            DetailsPolyfill.apply();
        }

        function renderVisitorsSummary(data) {
            const visitors = statisticsService.getVisitorTotals(data);
            const visitorsEl = element.querySelector(
                '[data-statistics-visitors]'
            );

            render(visitorsEl, 'visitors', visitors);
        }

        function renderNumbers(data) {
            const numbers = statisticsService.getVisitorTotals(data);
            const numbersEl = element.querySelector(
                '[data-statistics-numbers]'
            );
            render(numbersEl, 'numbers', numbers);
        }

        function renderVisitorsChart(data) {
            const visitors = statisticsService.getVisitorTotals(data);
            const chartEl = element.querySelector('[data-statistics-donut]');

            if (browserSupportsSVG()) {
                statisticsService.createVisitorsChart(chartEl, visitors);
            } else {
                render(chartEl, 'error', {
                    msg: 'Oppdater nettleseren for å se en graf for annonsen.',
                });
            }
        }

        function renderCountersChart(daysSincePublished, range, data) {
            let chart;

            const chartEl = element.querySelector(
                '[data-statistics-bar-chart]'
            );

            if (browserSupportsSVG()) {
                chart = statisticsService.createCountersChart(
                    chartEl,
                    data,
                    daysSincePublished,
                    range
                );
            } else {
                render(chartEl, 'error', {
                    msg: 'Oppdater nettleseren for å se en graf for annonsen.',
                });
            }

            statisticsService.setChartRange(
                chart,
                daysSincePublished,
                range,
                data
            );
        }

        function renderCounterSummary(daysSincePublished, range, data) {
            const summaryEl = element.querySelector(
                '[data-statistics-counters-summary]'
            );
            const totals = statisticsService.getCounterTotals(
                data,
                daysSincePublished,
                range
            );
            render(summaryEl, 'counters_summary', totals);
        }

        function getDaysSincePublished(totals) {
            return Object.keys(totals.dailyValues).length;
        }

        function render(element, template, data) {
            element.innerHTML = templateService.render(
                template,
                Object.assign(
                    {
                        realestate,
                    },
                    data
                )
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/statistics.js